const stageConfig = {
  BASE_URL: "http://3.16.194.5:8000/api/v1/",
};

const prodConfig = {
  BASE_URL: "https://api.parknstays.com/api/v1/",
};

export default "production" === process.env.REACT_APP_ENV ? prodConfig : stageConfig
